import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import GenericBasicInfo from "../../../../../../components/cards/GenericBasicInfo";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../../variables";
import PropTypes from "prop-types";
import _ from "lodash";
import { DateTime } from "luxon";
import { useQuery } from "@tanstack/react-query";
import { retrieveACTVendors } from "../../../../../../api/Vendor/Activitiy";
import { genericRequestErrorHandler } from "../../../../../../api";
import Loader from "../../../../../../components/Loader";
import VendorsDocuments from "../../../components/VendorsDocuments";
import ListPaymentTerms from "../../../components/paymentsTerms/ListPaymentTerms";
import TabStrip from "../../../../../../components/TabStrip";
import { CustomButton } from "../../../../../../components/CustomButton";
import VendorACTConfigLogsTab from "./VendorACTConfigLogsTab";
import DepositStatments from "../../../../CommonCRMModals/DepositStatmentss/DepositStatment";
import ProformaStatments from "../../../../CommonCRMModals/Proforma/List";
import { Price } from "../../../../../../components/Price";

const statusOptions = {
  "": "-----",
  AC: "Active",
  IN: "Inactive",
  CA: "Candidate",
};
const trueFalseMapping = {
  true: "Yes",
  false: "No",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DetailsActivitiesModal: {
    ...modalGenericStyles.modal,
  },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    display: "grid",
    padding: variables.double_gap,
    minHeight: "30vh",
    maxHeight: "70vh",
    overflow: "auto",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: cardStyles.card,
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: variables.normal_gap,
  },
  [`@media ${variables.media.smallscreen}`]: {
    cardBody: { justifyContent: "center" },
    row: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
});
const DetailsActivitiesModal = ({ id, onClose }) => {
  const classes = styles();

  const [activeTab, setActiveTab] = useState("basicData");

  const menuTabs = {
    basicData: "Basic Data",
    paymentTerms: "Payment Terms",
    proforma: "Proforma Statment",
    creditStatments: "Credit Statements",
    documents: "Documents",
    logs: "Logs",
  };

  const { data: Activity, isLoading: retrieveLoading } = useQuery({
    queryKey: ["DetailVendorAct", id],
    queryFn: async () => await retrieveACTVendors({ id: id }),
    onError: (error) => genericRequestErrorHandler(error),
  });

  const basicDataCpl = [
    ["Id", "id"],
    ["Member", "member"],
    ["Market Type", "market_type"],
    [
      "Notify Amount",
      null,
      <Price
        currency={Activity?.data?.vendor_data?.currency}
        price={Activity?.data?.notify_amount}
      />,
    ],
    ["Config uid", null, _.get(Activity, "data.config_uid[0]", "") || "N/A"],
    ["Notes", "notes"],
    [
      "Payment Validation",
      null,
      _.get(trueFalseMapping, _.get(Activity, "data.payment_validation")),
    ],
    ["CXL Strategy Time", "cxl_strategy_time"],
    [
      "CXL Strategy Daysahead",
      null,
      _.get(Activity, "data.cxl_strategy_daysahead", []) === 0
        ? "0"
        : _.get(Activity, "data.cxl_strategy_daysahead"),
    ],
    [
      "Block Non Refundable",
      null,
      _.get(trueFalseMapping, _.get(Activity, "data.block_nonrefundable")),
    ],
    [
      "Status",
      null,
      _.get(statusOptions, _.get(Activity, "data.status", "") || "N/A"),
    ],
  ];

  const creatorData = [
    ["Creator", "creator"],
    [
      "Created",
      null,
      DateTime.fromISO(_.get(Activity, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];
  const editorData = [
    ["Last Editor", "last_editor"],
    [
      "Edited",
      null,
      DateTime.fromISO(_.get(Activity, "data.edited")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];

  const VendorDataCpl = [
    ["base_url", "base_url"],
    ["client_id", "client_id"],
    ["currency", "currency"],
    ["grand_type", "grand_type"],
    ["x_musement_application", "x_musement_application"],
  ];

  const vendorContactData = [
    ["Title", "title"],
    ["First Name", "first_name"],
    ["Last Name", "last_name"],
    ["Email", "email"],
  ];

  return (
    <div id="DetailVendorACTModal" className={classes.DetailsActivitiesModal}>
      <div className={classes.modalCard}>
        <div className={classes.modalCardHeader}>
          <span>Details Activity Vendor</span>
        </div>
        <TabStrip
          tabs={Object.entries(menuTabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <div className={classes.modalCardBody}>
          {retrieveLoading ? (
            <Loader />
          ) : (
            <React.Fragment>
              {activeTab === "basicData" && (
                <React.Fragment>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Basic Data"}
                        cardInfo={basicDataCpl}
                        objectData={_.get(Activity, "data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Creator Data"}
                        cardInfo={creatorData}
                        objectData={_.get(Activity, "data", {})}
                      />
                      <GenericBasicInfo
                        header={"Editor Data"}
                        cardInfo={editorData}
                        objectData={_.get(Activity, "data", {})}
                      />
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Data"}
                        cardInfo={VendorDataCpl}
                        objectData={_.get(Activity, "data.vendor_data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Contact Data"}
                        cardInfo={vendorContactData}
                        objectData={_.get(
                          Activity,
                          "data.vendor_data.contact_details",
                          {}
                        )}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {activeTab === "paymentTerms" && (
                <ListPaymentTerms
                  showAddButton={true}
                  vendorId={_.get(Activity, "data.id")}
                />
              )}
              {activeTab === "proforma" && (
                <ProformaStatments
                  invalidationKey="DetailsSubAgentModal"
                  entityType="vendor"
                  entityData={_.get(Activity, "data", {})}
                />
              )}
              {activeTab === "creditStatments" && (
                <DepositStatments
                  invalidationKey="DetailVendorAct"
                  entityType="vendor"
                  entityData={_.get(Activity, "data", {})}
                />
              )}
              {activeTab === "documents" && (
                <VendorsDocuments
                  queryKey={`vendor_activity_document`}
                  tags={[`vendor__${_.get(Activity, "data.id")}`]}
                  entityData={_.get(Activity, "data", {})}
                />
              )}
            </React.Fragment>
          )}
          {activeTab === "logs" && <VendorACTConfigLogsTab />}
        </div>
        <div className={classes.modalCardActions}>
          <CustomButton id="cancel" appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DetailsActivitiesModal.propTypes = {
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DetailsActivitiesModal;
